import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Marquee from './components/Marquee';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingContact from './components/FloatingContact';
import InquiryPopup from './components/InquiryPopup';
import { Toaster } from './components/ui/toaster';

import Home from './pages/Home';
import About from './pages/About';
import MbbsInRussia from './pages/MbbsInRussia';
import UniversitiesList from './pages/UniversitiesList';
import UniversityDetail from './pages/UniversityDetail';
import FeeComparison from './pages/FeeComparison';
import Exams from './pages/Exams';
import Services from './pages/Services';
import Alumni from './pages/Alumni';
import StudentLife from './pages/StudentLife';
import Weather from './pages/Weather';
import Travel from './pages/Travel';
import Relations from './pages/Relations';
import Regional from './pages/Regional';
import News from './pages/News';
import Seminar from './pages/Seminar';
import VideoCounselling from './pages/VideoCounselling';
import UpcomingEvents from './pages/UpcomingEvents';
import Accommodation from './pages/Accommodation';
import VisaSupport from './pages/VisaSupport';
import NmcRegulations from './pages/NmcRegulations';
import AdmissionProcess from './pages/AdmissionProcess';
import Faqs from './pages/Faqs';
import Gallery from './pages/Gallery';
import ExamDetail from './pages/ExamDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminUniversityLogos from './pages/AdminUniversityLogos';
import AdminGallery from './pages/AdminGallery';
import AdminCMS from './pages/AdminCMS';
import NotFound from './pages/NotFound';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function AppShell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');
  return (
    <>
      {!isAdmin && <Marquee />}
      {!isAdmin && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/mbbs-in-russia" element={<MbbsInRussia />} />
          <Route path="/universities" element={<UniversitiesList />} />
          <Route path="/universities/fees" element={<FeeComparison />} />
          <Route path="/universities/:slug" element={<UniversityDetail />} />
          <Route path="/exams" element={<Exams />} />
          <Route path="/exams/:slug" element={<ExamDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/alumni" element={<Alumni />} />
          <Route path="/student-life" element={<StudentLife />} />
          <Route path="/weather-in-russia" element={<Weather />} />
          <Route path="/india-russia-travel" element={<Travel />} />
          <Route path="/india-russia-relations" element={<Relations />} />
          <Route path="/regional-connectivity" element={<Regional />} />
          <Route path="/news" element={<News />} />
          <Route path="/seminar" element={<Seminar />} />
          <Route path="/video-counselling" element={<VideoCounselling />} />
          <Route path="/upcoming-events" element={<UpcomingEvents />} />
          <Route path="/accommodation" element={<Accommodation />} />
          <Route path="/visa-support" element={<VisaSupport />} />
          <Route path="/nmc-regulations" element={<NmcRegulations />} />
          <Route path="/admission-process" element={<AdmissionProcess />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/universities" element={<AdminUniversityLogos />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/cms" element={<AdminCMS />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <FloatingContact />}
      {!isAdmin && <InquiryPopup />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App bg-white">
        <BrowserRouter>
          <ScrollToTop />
          <AppShell />
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
